import store404 from 'store/modules/Pages/404'
import store from 'definitions/store'

const Init = {
  init(name) {
    if (!store[name]) {
      store.registerModule(name, store404)

      Init.initDefaultValues(name)
    }
  },

  initDefaultValues(name) {

    if (typeof pageData !== "undefined") {
      store.commit(`${name}/setPageData`, pageData)
      store.commit(`${name}/setDiscoverNews`, pageData.discoverNews)
    }
  }
}

export default Init
